<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
    <el-form-item label="定价模式">
      <el-radio-group v-model="form.pricingModel" @change="modeChange" :disabled="id">
        <el-radio label="1">单位定价</el-radio>
        <el-radio label="2">按需定价</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-row style="height: 200px">
      <el-col span="1"></el-col>
      <el-col span="23">
        <!-- 单位定价 -->
        <el-form-item label="算费费率" prop="feePrice" style="display：flex" v-if="form.pricingModel == 1">
          <el-row gutter="10">
            <el-col span="6">
              <el-input type="text" v-model="form.feePrice" style="width: 100%" :disabled="id" maxlength="10" :show-word-limit="true"></el-input>


            </el-col>
            <el-col span="2">
              元
            </el-col>
            <el-col span="3">
              <el-select v-model="form.feeUnit" placeholder="请选择" style="width: 100%" :disabled="id">
                <template v-for="(item, index) in dicts.fee_standard_unit">
                  <el-option
                    v-if="item.dictKey[0] == fee_standard_unit_first_number"
                    :key="index"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </template>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 按需定价 -->
        <el-form-item label="" v-if="form.pricingModel == 2" >
          <el-row gutter="10"> 设置后可以自定义缴费金额 </el-row>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    form: Object,
    dicts: Object,
    id:String
  },
  data() {
    return {
      fee_standard_unit_first_number: '4',
      rules:{
        feePrice: [
          { required: true, message: '请输入费率', trigger: 'change' },
          { validator:(rule,value,cb)=>{
            value = value + '';
            console.log('value==>',value);
            if(!/^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/.test(value)){
              cb(new Error('金额格式错误'))
            }else{
              cb()
            }
          }, message: '格式错误', trigger: 'change' },
        ],
        pricingModel:[{ required: true, message: '请选择', trigger: 'change' }],
      },
    };
  },
  methods: {
    modeChange(val) {
      console.log('val==>', val);
    },
    validate() {
      return new Promise((resolve, rej) => {
        this.$refs.form
          .validate()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    setInitValue() {
      if (this.dicts) {
        //算费费率单位
        if (this.dicts.fee_standard_unit) {
          for (let i = 0; i < this.dicts.fee_standard_unit.length; i++) {
            let item = this.dicts.fee_standard_unit[i];
            if (item.dictKey[0] == this.fee_standard_unit_first_number) {
              this.form.feeUnit = item.dictKey;
              break;
            }
          }
        }
      }
    },
  },
  created(){
    this.setInitValue();
  }
};
</script>